export default __webpack_public_path__ + "images/upload-file.svg";